<template>
  <div class="container">
    <p>
      These numbers lie still, but not for those who know the secrets. You must
      find the ways to make them move.
    </p>
    <div class="code-container">
      <div
        v-for="i in 9"
        :id="`button-${i}`"
        :ref="i"
        :key="i"
        class="code-button noSelect"
      >
        {{ i }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tutorial1',
}
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
}

p {
  margin-bottom: 2em;
}

.code-container {
  color: #cdf4dd;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  row-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  /*column-gap: 0.75rem;*/
  /*row-gap: 0.75rem;*/
}

.code-button {
  /*width: 3rem; 
  height: 3rem;*/
  width: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  height: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  border-radius: 50%;
  border: 0.5px solid #cdf4dd;
  display: flex;
  justify-content: center;
  align-items: center;
  /*font-size: 2rem;*/
  font-size: calc(clamp(1rem, 8.8vmin, 2.5rem) / 1.5);
  font-family: 'Open Sans';
  font-weight: 100;
  cursor: pointer;
  user-select: none;
}

.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
